import React from 'react';

import { Button, SvgIcon } from '@mui/material';

import { Mode } from '../../../../general-types';
import { ConfirmButtonsBlock } from '../ConfirmButtonsBlock/ConfirmButtonsBlock';
import { ReactComponent as PenIcon } from '../../../assets/icons/pen.svg';

export type ModeButtonsBlockProps = {
  mode: Mode;
  onEdit?: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  disabledSubmit?: boolean;
};

const ModeButtonsBlock = ({
  mode,
  onEdit,
  onCancel,
  onSubmit,
  disabledSubmit,
}: ModeButtonsBlockProps) => {
  return mode === 'VIEW' ? (
    <Button
      variant="text"
      size="small"
      color="secondary"
      onClick={onEdit}
      startIcon={<SvgIcon component={PenIcon} inheritViewBox fontSize="small" />}
    >
      Edit
    </Button>
  ) : (
    <ConfirmButtonsBlock
      onCancel={onCancel}
      onConfirm={onSubmit}
      yesDisabled={disabledSubmit}
      noText="Cancel"
      yesText="Save"
      size="small"
    />
  );
};

export { ModeButtonsBlock };
